
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as loginyS_635ZNODza5tjO9y_Kjsm5BWP5YDEqDSMaxBi9pVEMeta } from "/vercel/path0/pages/auth/login.vue?macro=true";
import { default as registerIX_45armKv67kSdaASoB7cQfyrz3LZboEMzGLID7Lgxz8Meta } from "/vercel/path0/pages/auth/register.vue?macro=true";
import { default as indexcgj1YhTOlUth3jdoUCCx0gwsOKYltazOce0k7q7mnxcMeta } from "/vercel/path0/pages/dashboard/index.vue?macro=true";
import { default as _91id_93mg7z0Dkf8GpzjHiVeSnWW_45sP9MfCmkd36s0k_452NVlDcMeta } from "/vercel/path0/pages/dashboard/resume/[id].vue?macro=true";
import { default as indexpdgrxUzpAW9_NvIqZTA0Ar53yPNRgX3Jm9249aFDAL0Meta } from "/vercel/path0/pages/dashboard/generate/index.vue?macro=true";
import { default as indexQuiGcRWrrd5y9Xd69u_45LkgS2_V_45dk24Kxg1LXSqYErIMeta } from "/vercel/path0/pages/dashboard/settings/index.vue?macro=true";
export default [
  {
    name: "index___zh",
    path: "/zh",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "auth-login___zh",
    path: "/zh/auth/login",
    meta: loginyS_635ZNODza5tjO9y_Kjsm5BWP5YDEqDSMaxBi9pVEMeta || {},
    component: () => import("/vercel/path0/pages/auth/login.vue")
  },
  {
    name: "auth-login___en",
    path: "/auth/login",
    meta: loginyS_635ZNODza5tjO9y_Kjsm5BWP5YDEqDSMaxBi9pVEMeta || {},
    component: () => import("/vercel/path0/pages/auth/login.vue")
  },
  {
    name: "auth-register___zh",
    path: "/zh/auth/register",
    meta: registerIX_45armKv67kSdaASoB7cQfyrz3LZboEMzGLID7Lgxz8Meta || {},
    component: () => import("/vercel/path0/pages/auth/register.vue")
  },
  {
    name: "auth-register___en",
    path: "/auth/register",
    meta: registerIX_45armKv67kSdaASoB7cQfyrz3LZboEMzGLID7Lgxz8Meta || {},
    component: () => import("/vercel/path0/pages/auth/register.vue")
  },
  {
    name: "dashboard___zh",
    path: "/zh/dashboard",
    meta: indexcgj1YhTOlUth3jdoUCCx0gwsOKYltazOce0k7q7mnxcMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/index.vue")
  },
  {
    name: "dashboard___en",
    path: "/dashboard",
    meta: indexcgj1YhTOlUth3jdoUCCx0gwsOKYltazOce0k7q7mnxcMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-resume-id___zh",
    path: "/zh/dashboard/resume/:id()",
    meta: _91id_93mg7z0Dkf8GpzjHiVeSnWW_45sP9MfCmkd36s0k_452NVlDcMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/resume/[id].vue")
  },
  {
    name: "dashboard-resume-id___en",
    path: "/dashboard/resume/:id()",
    meta: _91id_93mg7z0Dkf8GpzjHiVeSnWW_45sP9MfCmkd36s0k_452NVlDcMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/resume/[id].vue")
  },
  {
    name: "dashboard-generate___zh",
    path: "/zh/dashboard/generate",
    meta: indexpdgrxUzpAW9_NvIqZTA0Ar53yPNRgX3Jm9249aFDAL0Meta || {},
    component: () => import("/vercel/path0/pages/dashboard/generate/index.vue")
  },
  {
    name: "dashboard-generate___en",
    path: "/dashboard/generate",
    meta: indexpdgrxUzpAW9_NvIqZTA0Ar53yPNRgX3Jm9249aFDAL0Meta || {},
    component: () => import("/vercel/path0/pages/dashboard/generate/index.vue")
  },
  {
    name: "dashboard-settings___zh",
    path: "/zh/dashboard/settings",
    meta: indexQuiGcRWrrd5y9Xd69u_45LkgS2_V_45dk24Kxg1LXSqYErIMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/settings/index.vue")
  },
  {
    name: "dashboard-settings___en",
    path: "/dashboard/settings",
    meta: indexQuiGcRWrrd5y9Xd69u_45LkgS2_V_45dk24Kxg1LXSqYErIMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/settings/index.vue")
  }
]